// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CarFilledSvg from "@ant-design/icons-svg/es/asn/CarFilled";
import AntdIcon from '../components/AntdIcon';

var CarFilled = function CarFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: CarFilledSvg
  }));
};

CarFilled.displayName = 'CarFilled';
export default React.forwardRef(CarFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/CarFilled.js
// module id = 719
// module chunks = 0